import { ChangeDetectionStrategy, Component } from "@angular/core";
import { addIcons } from "ionicons";
import { closeCircleOutline } from "ionicons/icons";
import { IonIcon } from "@ionic/angular/standalone";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
	selector: "ic-unsupported-app-version",
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [IonIcon, TranslatePipe],
	template: `<div><ion-icon name="close-circle-outline" [style.font-size]="'4rem'" /></div>
		<h1 [style.font-size]="'1.5rem'" [style.margin-block]="'1rem'" [style.text-wrap]="'balance'">
			{{ "appSunsetPage.title" | translate }}
		</h1>
		<div [innerHTML]="'appSunsetPage.messageHTML' | translate" [style.text-wrap]="'pretty'"></div>`,
	host: {
		class: "bg-auth-accent",
		"[style.padding]": "'2rem'",
		"[style.color]": "'white'",
		"[style.text-align]": "'center'",
		"[style.display]": "'flex'",
		"[style.justify-content]": "'center'",
	},
})
export class UnsupportedAppVersionContainer {
	constructor() {
		addIcons({ closeCircleOutline });
	}
}
